import React from "react";
import { Button, Col } from "react-bootstrap";
import ReactLoading from "react-loading";
import * as XLSX from "xlsx";

import "./Buttons.css";
function BtnExcel({
  size,
  isClicked,
  label,
  excelData,
  xlsxHeaders,
  fileName,
}) {
  function handleExport() {
    const rows = excelData;
    /* generate worksheet and workbook */
    const worksheet = XLSX.utils.json_to_sheet(rows);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet 1");
    XLSX.utils.sheet_add_aoa(worksheet, [xlsxHeaders], { origin: "A1" });
    XLSX.writeFile(workbook, fileName, { compression: true });
  }

  return (
    <Col className="p-1">
      {isClicked ? (
        <Button className="action-btn clear loader" size={size}>
          <ReactLoading type={"balls"} height={20} width={25} color="#000000" />
        </Button>
      ) : (
        <Button className="action-btn clear" size={size} onClick={handleExport}>
          {label}
        </Button>
      )}
    </Col>
  );
}

export default BtnExcel;
